import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';


const useStyles = makeStyles(() => {
  return {
    subscribeButton: {
      color: '#fff',
      background: 'linear-gradient(180deg, #dd1369, #920e73)',
      maxWidth: 'fit-content',
      margin: '20px auto 0px',
      border: 'none',
      borderRadius: 25,
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 5,
      paddingBottom: 5,
      fontSize: '16px',
      fontFamily: 'Roboto, Arial, Helvetica, sans-serif !important',
      '&:hover': { backgroundColor: '#8a1816' },
    },
  };
});

function SubscribeToViewCTAButton(props) {
  const { showButton } = props;
  const classes = useStyles();

  if (!showButton) {
    return null;
  }

  return (
    <Box className={classes.subscribeButton}>
      Subscribe to view
    </Box>
  );
}


export default React.memo(SubscribeToViewCTAButton);

SubscribeToViewCTAButton.propTypes = { showButton: PropTypes.bool.isRequired };
